module.exports = __webpack_public_path__ + "img/certificate03-1-3.ce3f3dba.jpg";